import { render, staticRenderFns } from "./03_ap_tipo_contenedores.vue?vue&type=template&id=2a87dc8e&scoped=true&"
import script from "./03_ap_tipo_contenedores.vue?vue&type=script&lang=js&"
export * from "./03_ap_tipo_contenedores.vue?vue&type=script&lang=js&"
import style0 from "./03_ap_tipo_contenedores.vue?vue&type=style&index=0&id=2a87dc8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a87dc8e",
  null
  
)

export default component.exports